module.exports = __webpack_public_path__ + "static/media/popup_si.e713c082.png";